import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "cover-upload-aria flex-center"
};
var _hoisted_2 = {
    key: 1,
    class: "uploaded-cover-container"
};
var _hoisted_3 = { class: "postimg-container" };
var _hoisted_4 = ["src"];
var _hoisted_5 = { class: "img-editor-form" };
var _hoisted_6 = { class: "img-editor-modal-footer" };
import { ref, watch, computed, toRef } from "vue";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CoverUploader',
    props: {
        modelValue: File,
    },
    emits: ["update:modelValue"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        // 组件的工作原理是双向绑定传入值，上传只是改变绑定值，需要在组件外额外监听变化然后触发上传操作（懒鬼操作）
        var acceptType = [
            "png",
            "jpeg",
            "jpg",
            "gif",
            "svg",
            "webp",
            "bmp",
            "jfif",
            "pjpeg",
        ];
        var emit = __emit;
        var props = __props;
        var modelValue = toRef(props.modelValue);
        var modelValueFileCastURL = computed(function () {
            return modelValue.value ? window.URL.createObjectURL(modelValue.value) : "";
        });
        watch(modelValue, function (newValue) {
            // 当 bindValue 发生变化时，触发 update:bind-value 事件
            emit("update:modelValue", newValue); // 双向绑定受控，发送事件使得传来的值能发生变化
        });
        var uploadedFile = ref(null);
        var handleChange = function (fileObj) {
            var file = fileObj.file;
            var fileExtension = file.name.split(".").pop() || "";
            if (acceptType.includes(fileExtension) && file.file) {
                uploadedFile.value = file.file;
                editImageUrl.value = window.URL.createObjectURL(uploadedFile.value);
                isShowImgEditModal.value = true;
            }
            else {
                console.log("文件类型不支持");
                window.$message.error("文件类型不支持");
            }
        };
        // 编辑上传的图片相关
        var isShowImgEditModal = ref(false);
        var editImageUrl = ref("");
        var cropperRef = ref(null);
        var croppedBlob = ref(null);
        function defaultSize(_a) {
            var imageSize = _a.imageSize, visibleArea = _a.visibleArea;
            var aria = visibleArea || imageSize;
            return {
                width: aria.width,
                height: aria.height,
            };
        }
        function applyCrop() {
            var cropper = cropperRef.value;
            if (!cropper)
                return;
            var canvas = cropper.getResult().canvas;
            if (!canvas)
                return;
            if (!uploadedFile.value) {
                window.$message.error("请先上传图片");
                return;
            }
            canvas.toBlob(function (blob) {
                if (blob && uploadedFile.value) {
                    croppedBlob.value = blob;
                    modelValue.value = new File([blob], uploadedFile.value.name, {
                        type: blob.type,
                        lastModified: Date.now(),
                    });
                    isShowImgEditModal.value = false;
                    window.$message.success("图片编辑成功");
                }
            }, uploadedFile.value.type);
        }
        return function (_ctx, _cache) {
            var _component_n_upload = _resolveComponent("n-upload");
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_card = _resolveComponent("n-card");
            var _component_n_modal = _resolveComponent("n-modal");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_n_upload, {
                    ref: "upload",
                    "default-upload": false,
                    "directory-dnd": "",
                    onChange: handleChange,
                    "show-file-list": false
                }, {
                    default: _withCtx(function () { return [
                        (!modelValue.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [
                                _createElementVNode("i", { class: "fa-solid fa-image" }, null, -1)
                            ])))
                            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("img", {
                                        src: modelValueFileCastURL.value,
                                        alt: "cover",
                                        class: "postimg-container"
                                    }, null, 8, _hoisted_4)
                                ])
                            ]))
                    ]; }),
                    _: 1
                }, 512),
                _createVNode(_component_n_modal, {
                    show: isShowImgEditModal.value,
                    "onUpdate:show": _cache[2] || (_cache[2] = function ($event) { return ((isShowImgEditModal).value = $event); }),
                    draggable: "",
                    closable: "",
                    class: "usn"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_n_card, {
                            style: { "width": "750px" },
                            title: "编辑封面",
                            bordered: false,
                            size: "huge",
                            role: "dialog",
                            "aria-modal": "true"
                        }, {
                            "header-extra": _withCtx(function () { return [
                                _createVNode(_component_n_icon, {
                                    size: "1.6rem",
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return (isShowImgEditModal.value = false); })
                                }, {
                                    default: _withCtx(function () { return _cache[4] || (_cache[4] = [
                                        _createElementVNode("i", { class: "fa-solid fa-square-xmark fa-close-style" }, null, -1)
                                    ]); }),
                                    _: 1
                                })
                            ]; }),
                            footer: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_n_button, {
                                        onClick: _cache[1] || (_cache[1] = function ($event) { return (isShowImgEditModal.value = false); })
                                    }, {
                                        default: _withCtx(function () { return _cache[5] || (_cache[5] = [
                                            _createTextVNode("取消")
                                        ]); }),
                                        _: 1
                                    }),
                                    _createVNode(_component_n_button, {
                                        type: "primary",
                                        onClick: applyCrop
                                    }, {
                                        default: _withCtx(function () { return _cache[6] || (_cache[6] = [
                                            _createTextVNode("确定")
                                        ]); }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_unref(Cropper), {
                                        src: editImageUrl.value,
                                        class: "cropper-editor",
                                        ref_key: "cropperRef",
                                        ref: cropperRef,
                                        quality: 1,
                                        "default-size": defaultSize
                                    }, null, 8, ["src"])
                                ])
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ], 64));
        };
    }
});
